/**
 * Copyright (c) 2025 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useEffect, useState } from 'react';
import { PARAMS } from '../definitions/RouterStates';
import { useSearchParams } from './useSearchParams';
import { getConfig } from '@utils/configs';

/*
 * The offshore QA team sometimes gets blocked by network tests due to their latency being higher.
 * This hook allows them to skip network tests by adding a query parameter to the URL.
 *
 * Note: This should only be available in non-prod environments.
 */
export function useSkipNetworkTests() {
  const { nodeEnv } = getConfig();
  const searchParams = useSearchParams();
  const [skipNetworkTests, setSkipNetworkTests] = useState(false);

  useEffect(() => {
    if (nodeEnv === 'prod') {
      return;
    }

    if (searchParams.get(PARAMS.SKIP_NETWORK_TEST) === 'true') {
      setSkipNetworkTests(true);
    }
  }, [searchParams]);

  return skipNetworkTests;
}
